import React from 'react'
import {motion} from 'framer-motion'
import { useTranslation} from "react-i18next";

import {images} from '../../constants'

import './Header.scss'

import {AppWrap} from '../../wrappers'

const scaleVariants= {
whileInView:{
  scale:[0,1],
  opacity:[0,1],
  transition: {
    duration:1,
    ease:'easeInOut'
  }
}
}

const getRandomProfile=(min, max) =>{
  const randomNumber= parseInt(Math.random() * (max - min) + min)
  return images[`profile${randomNumber}`]
}

const Header = () => {
  const { t } = useTranslation();
  return (
    <div className='app__header app__flex'>
      <motion.div 
      whileInView={{x:[-100,0],opacity:[0,1]}}
      transition={{duration:0.5}}
      className='app__header-info'
      >
        <div className='app__header-badge'>
          <div className='badge-cmp app__flex'>
            <span>🤌</span>
            <div style={{marginLeft:20}}>
              <p className='p-text'>{t('greetings')}</p>
              <h1 className='head-text'>{t('name')} <img src={images.tn} alt="Tunisian Flag" width = "50px"/></h1>
            </div>
          </div>
          <div className='tag-cmp app__flex'>
          <p className='p-text'>{t('main-title')}</p>
          <p className='p-text'>{t('aux-title')}</p>
          </div>
        </div>
      </motion.div>

      <motion.div
         whileInView={{opacity:[0,1]}}
         transition={{duration:0.5,delayChildren:0.5}}
         className='app__header-img'>
           <img src={getRandomProfile(1,5)} alt='profile_bg'/>

           <motion.img
             whileInView={{scale:[0,1]}}
             transition={{duration:1,ease:'easeInOut'}}
             className='overlay_circle'
             src={images.circle}
             alt='profile_circle'/>
      </motion.div>

      <motion.div
      variant={scaleVariants}
      whileInView={scaleVariants.whileInView}
      className='app__header-circles'
      >
        {[images.node,images.angular_react,images.csharp].map((circle,index) =>
     (     <div className='circle-cmp app__flex' key={`circle-${index}`}>
            <img src={circle} alt='circle'/>
          </div>)
        )}
        
        </motion.div>
    </div>
  )
}

export default AppWrap(Header,'home')